import type {
  ScheduleWriteBody,
  WorkflowFrequency,
  WorkflowSchedule,
} from '../models/workflow.types'

export interface ScheduleDraft {
  workflowId: number | string
  frequency: WorkflowFrequency
  localTime: string
  timezone: string
  dayOfWeek: number | null
  dayOfMonth: number | null
}

export type ScheduleField = 'frequency' | 'localTime' | 'timezone' | 'dayOfWeek' | 'dayOfMonth'
export type ScheduleFieldErrors = Partial<Record<ScheduleField, string>>

export function validateScheduleDraft(draft: ScheduleDraft): ScheduleFieldErrors {
  const errors: ScheduleFieldErrors = {}
  if (!draft.frequency) errors.frequency = 'workflow.schedule.validation.frequency'
  if (draft.frequency !== 'one_time') {
    if (!draft.localTime) errors.localTime = 'workflow.schedule.validation.time'
    if (!draft.timezone) errors.timezone = 'workflow.schedule.validation.timezone'
  }
  if (draft.frequency === 'weekly' && draft.dayOfWeek === null) {
    errors.dayOfWeek = 'workflow.schedule.validation.day'
  }
  if (draft.frequency === 'monthly' && draft.dayOfMonth === null) {
    errors.dayOfMonth = 'workflow.schedule.validation.dayOfMonth'
  }
  return errors
}

export function buildScheduleBody(draft: ScheduleDraft): ScheduleWriteBody {
  const recurring = draft.frequency !== 'one_time'
  return {
    workflow_id: draft.workflowId,
    frequency: draft.frequency,
    local_time: recurring ? draft.localTime : null,
    timezone: recurring ? draft.timezone : null,
    day_of_week: draft.frequency === 'weekly' ? draft.dayOfWeek : null,
    day_of_month: draft.frequency === 'monthly' ? draft.dayOfMonth : null,
    is_active: true,
  }
}

export function draftFromSchedule(
  workflowId: number | string,
  timezone: string,
  schedule?: WorkflowSchedule | null,
): ScheduleDraft {
  return {
    workflowId,
    frequency: schedule?.frequency ?? 'weekly',
    localTime: schedule?.local_time?.slice(0, 5) ?? '09:00',
    timezone: schedule?.timezone ?? timezone,
    dayOfWeek: schedule?.day_of_week ?? 0,
    dayOfMonth: schedule?.day_of_month ?? 1,
  }
}

export function scheduleStatus(schedule: WorkflowSchedule): 'active' | 'paused' {
  return schedule.is_active ? 'active' : 'paused'
}
